"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.object.entries");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.object.define-property");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Themes_1 = require("../../../constants/Themes");

exports.Footer = function (_a) {
  var id = _a.id,
      className = _a.className,
      contactArea = _a.contactArea,
      children = _a.children,
      theme = _a.theme,
      previousTheme = _a.previousTheme;
  var themeSuffix = theme && Object.entries(Themes_1.Themes).find(function (entry) {
    return entry[0] !== "DEFAULT" && entry[1] === theme;
  })[0].toLowerCase();
  var previousThemeSuffix = previousTheme && Object.entries(Themes_1.Themes).find(function (entry) {
    return entry[0] !== "DEFAULT" && entry[1] === previousTheme;
  })[0].toLowerCase();
  return React.createElement("footer", {
    id: id,
    className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "footer", className, themeSuffix && CSSPrefix_1.lsgPre + "footer-theme__" + themeSuffix, previousThemeSuffix && contactArea && CSSPrefix_1.lsgPre + "footer-previoustheme__" + previousThemeSuffix])
  }, React.createElement("div", {
    className: CSSPrefix_1.lsgPre + "footer-contactarea"
  }, contactArea), React.createElement("div", {
    className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "footer-inner", CSSPrefix_1.prefixEnumClassNames(theme)])
  }, children));
};

exports.Footer.displayName = "Footer";